var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('sysmenu'),_c('div',{class:['rightcontent']},[_c('div',{class:['rightpage']},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }